import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { useCheckMobileScreen } from "../../../useCheckMobileScreen";

export interface Props {
  id: string;
  index: number;
  onClick: () => void;
  isActive: boolean;
  title: string;
}

export function SurveyButton(props: Props) {
  const isMobile = useCheckMobileScreen();

  return (
    <Flex
      id={props.id}
      flex={1}
      direction="column"
      alignItems="center"
      justifyContent="center"
      minW={isMobile ? "calc(50% - 0.5rem)" : 0}
      minH={isMobile ? "90px" : "110px"}
      px={3}
      py={4}
      cursor="pointer"
      border="1px solid"
      borderColor={props.isActive ? "teal.500" : "whiteAlpha.100"}
      borderRadius="xl"
      bg={props.isActive ? undefined : "whiteAlpha.50"}
      bgGradient={
        props.isActive ? "linear(to-br, teal.800, teal.600)" : undefined
      }
      boxShadow={
        props.isActive ? "0 4px 20px rgba(56, 178, 172, 0.2)" : "none"
      }
      transform={props.isActive ? "translateY(-3px)" : "translateY(0)"}
      transition="all 0.18s ease"
      _hover={{
        borderColor: props.isActive ? "teal.400" : "whiteAlpha.300",
        bg: props.isActive ? undefined : "whiteAlpha.100",
        transform: "translateY(-3px)",
        boxShadow: props.isActive
          ? "0 4px 20px rgba(56, 178, 172, 0.2)"
          : "0 4px 12px rgba(0,0,0,0.2)",
      }}
      onClick={props.onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") props.onClick();
      }}
    >
      <Flex
        w="28px"
        h="28px"
        borderRadius="full"
        bg={props.isActive ? "teal.300" : "whiteAlpha.100"}
        border="1px solid"
        borderColor={props.isActive ? "teal.200" : "whiteAlpha.200"}
        alignItems="center"
        justifyContent="center"
        mb={2}
        flexShrink={0}
        transition="all 0.18s ease"
      >
        <Text
          fontSize="xs"
          fontWeight="bold"
          color={props.isActive ? "teal.900" : "gray.500"}
        >
          {props.index + 1}
        </Text>
      </Flex>
      <Text
        fontSize={isMobile ? "0.68rem" : "0.82rem"}
        color={props.isActive ? "white" : "gray.400"}
        textAlign="center"
        fontWeight={props.isActive ? "medium" : "normal"}
        transition="color 0.18s ease"
        lineHeight="short"
        style={{ whiteSpace: "normal", wordWrap: "break-word" }}
      >
        {props.title}
      </Text>
    </Flex>
  );
}
